/* Countdown carrello AVRA - 10:00 minuti, persistente tra i re-render del cassetto */
(function () {
  var DURATION = 10 * 60 * 1000; // 10 minuti in ms
  var KEY = 'avra_cart_countdown_end';

  function getEnd() {
    var end = parseInt(sessionStorage.getItem(KEY), 10);
    var now = Date.now();
    if (!end || isNaN(end) || end <= now) {
      end = now + DURATION;
      sessionStorage.setItem(KEY, String(end));
    }
    return end;
  }

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function render() {
    var els = document.querySelectorAll('[data-cart-countdown]');
    if (!els.length) return;
    var diff = getEnd() - Date.now();
    if (diff < 0) diff = 0;
    var totalSec = Math.floor(diff / 1000);
    var text = pad(Math.floor(totalSec / 60)) + ':' + pad(totalSec % 60);
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = text;
    }
  }

  render();
  setInterval(render, 1000);
})();
